import {userLogin, userLogout, proxyLogin, tokenLogin} from '@/api/common'
import {getStorage, setStorage, removeStorage} from '@/hook/useStorage'
import {USER_TOKEN, PROXY_TOKEN_STORAGE, PROXY_ID} from "@/hook/useConstant";
import router from "@/router";
import store from '@/store'

// 登录
export const loginIn = (param) => {
    return new Promise((resolve, reject) => {
        userLogin(param).then(res => {
            if (res.code === 0) {
                setStorage(USER_TOKEN, res.data.access_token)

                resolve()
            }
        }).catch(err => {
            reject()
        })
    })
}

// 退出登录
export const loginOut = () => {
    return new Promise((resolve, reject) => {
        userLogout().then(res => {
            if (res.code === 0) {
                store.commit('SET_USERINFO', null)
                store.commit('SET_MENU', [])

                removeStorage(USER_TOKEN)
                removeStorage(PROXY_TOKEN_STORAGE)

                router.push({
                    name: 'login'
                })

                resolve()
            }
        })
    })
}

// 免密登录
export const noPwdLogin = (userId) => {
    let _param = {
        user_id: userId
    }
    proxyLogin(_param).then(res => {
        if (res.code === 0) {
            // 记录原账号token
            let _token = getStorage(USER_TOKEN)
            setStorage(PROXY_TOKEN_STORAGE, _token)
            setStorage(PROXY_ID, store.state.userInfo.id)

            // 设置新的token
            setStorage(USER_TOKEN, res.data.access_token)

            store.dispatch('getUserInfo').then(r => {
                store.dispatch('getUserPermission').then(a => {
                    router.replace({name: 'index'})
                })
            })
        }
    })
}

// 返回代登录账号
export const backProxyLogin = () => {
    setStorage(USER_TOKEN, getStorage(PROXY_TOKEN_STORAGE))

    tokenLogin().then(res => {
        if (res.code === 0) {

            removeStorage(PROXY_TOKEN_STORAGE)
            removeStorage(PROXY_ID)

            // 设置新的token
            setStorage(USER_TOKEN, res.data.access_token)

            store.dispatch('getUserInfo').then(r => {
                store.dispatch('getUserPermission').then(a => {
                    router.replace({name: 'index'})
                })
            })
        }
    })
}